import React, { useId } from 'react';
import classNames from 'classnames';
import { ErrorMessage, useFormikContext } from 'formik';
const Textarea = ({ helpText, label, name, ...props }) => {
    const uniqueId = useId();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { errors, touched } = useFormikContext();
    const hasError = errors[name] && touched[name];
    return (React.createElement("div", { className: classNames('form-element-textarea', { 'has-error': hasError }) },
        label && (React.createElement("label", { className: 'form-element-label', htmlFor: name + '_' + uniqueId }, label)),
        React.createElement("div", { className: 'form-element-container' },
            React.createElement("textarea", { name: name, id: name + '_' + uniqueId, ...props })),
        helpText && React.createElement("p", { className: 'form-elements-help-text' }, helpText),
        hasError && (React.createElement("p", { className: 'form-elements-error-message' },
            React.createElement(ErrorMessage, { name: name })))));
};
export default Textarea;
